import React from 'react';

/**
 * Célula individual de uma unidade no mapa de vendas.
 */
function UnitCell({ unit, cfg, formatCurrency }) {
    const tooltip = [
        `${unit.unit} — ${cfg.label}`,
        unit.value ? formatCurrency(unit.value) : null,
        unit.cardeal_point ? unit.cardeal_point : null,
        unit.side ? unit.side : null,
    ]
        .filter(Boolean)
        .join(' — ');

    return (
        <div
            className="unit-cell"
            style={{ backgroundColor: cfg.color, color: cfg.textColor }}
            title={tooltip}
        >
            <div className="unit-name">{unit.unit}</div>
            <div className="unit-status-label">{cfg.label.toUpperCase()}</div>
            {unit.value && (
                <div className="unit-value">{formatCurrency(unit.value)}</div>
            )}
        </div>
    );
}

export default UnitCell;
